import { render } from "./FormHistoriaClinica.vue?vue&type=template&id=e6241382&scoped=true"
import script from "./FormHistoriaClinica.vue?vue&type=script&lang=js"
export * from "./FormHistoriaClinica.vue?vue&type=script&lang=js"

import "./FormHistoriaClinica.vue?vue&type=style&index=0&id=e6241382&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6241382"]])

export default __exports__